import React, { useCallback, useMemo } from 'react';
import { DataSets } from 'libs/end-to-end/src/types/databases/data-sets/data-sets';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';

export const DataSetSelector = ({
  dataSetId,
  setDataSetId,
  dataSets,
  label,
}: {
  dataSetId: string | null;
  setDataSetId: (dataSetId: string | null) => void;
  dataSets: DataSets['dataSets'];
  label: string;
}) => {
  const list = useMemo(() => {
    const noneItem = {
      optionLabel: 'None',
      optionValue: 'none',
    };

    return [
      noneItem,
      ...dataSets.map((dataSet) => ({
        optionLabel: dataSet.displayName,
        optionValue: dataSet.id,
      })),
    ];
  }, [dataSets]);

  const setSelected = useCallback(
    (selected: string) => {
      if (selected === 'none') {
        setDataSetId(null);
      } else {
        setDataSetId(selected);
      }
    },
    [setDataSetId],
  );

  return (
    <SelectBoxWithSearch
      type="single"
      list={list}
      selected={dataSetId ?? 'none'}
      label={label}
      setSelected={setSelected}
    />
  );
};
